import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
export default class ReaderException extends Exception {
}
//# sourceMappingURL=ReaderException.js.map